module.exports = __webpack_public_path__ + "static/media/plus.d0424d6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/plus.svg
// module id = 1205
// module chunks = 0